import React from 'react';

// Base wrapper keeps every sidebar glyph rendering at 17x17. The viewBox is
// overridable so glyphs lifted from a 24-grid icon set keep their proportions.
const SidebarIcon = ({ children, viewBox = '0 0 17 17' }) => (
  <svg
    width="17"
    height="17"
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const HomeIcon = () => (
  <SidebarIcon>
    <path
      d="M2.83334 8.02776L8.50001 2.83331L14.1667 8.02776M4.72223 7.08331V14.1666H12.2778V7.08331"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const DashboardIcon = HomeIcon;

// Building — the same glyph the startup app uses for a company page.
export const StartupsIcon = () => (
  <SidebarIcon>
    <path
      d="M6.13888 7.55554H7.08333M6.13888 10.3889H7.08333M9.91666 7.55554H10.8611M9.91666 10.3889H10.8611M3.77777 14.6389V4.7222L8.49999 2.83331L13.2222 4.7222V14.6389H3.77777Z"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const InvestorsIcon = () => (
  <SidebarIcon>
    <path
      d="M6.61113 8.31112C7.81081 8.31112 8.78335 7.33858 8.78335 6.1389C8.78335 4.93921 7.81081 3.96667 6.61113 3.96667C5.41144 3.96667 4.4389 4.93921 4.4389 6.1389C4.4389 7.33858 5.41144 8.31112 6.61113 8.31112Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M2.36111 14.1667V12.75C2.36111 11.9985 2.65963 11.2779 3.19098 10.7465C3.72233 10.2152 4.443 9.91666 5.19445 9.91666H8.02778C8.77923 9.91666 9.4999 10.2152 10.0313 10.7465C10.5626 11.2779 10.8611 11.9985 10.8611 12.75V14.1667"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M11.8055 6.79999C11.8999 6.7929 11.9946 6.7929 12.0889 6.79999C12.5898 6.79999 13.0703 6.60099 13.4245 6.24675C13.7788 5.89252 13.9778 5.41207 13.9778 4.91111C13.9778 4.41014 13.7788 3.92969 13.4245 3.57546C13.0703 3.22122 12.5898 3.02222 12.0889 3.02222M12.2778 10.0111H13.0333C13.7186 10.0797 14.3555 10.3956 14.8248 10.8997C15.2941 11.4038 15.5638 12.0615 15.5833 12.75V14.1667"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

// Coin — purchases / revenue.
export const PurchasesIcon = () => (
  <SidebarIcon>
    <path
      d="M8.5 14.7333C11.9426 14.7333 14.7333 11.9426 14.7333 8.5C14.7333 5.05742 11.9426 2.26666 8.5 2.26666C5.05742 2.26666 2.26666 5.05742 2.26666 8.5C2.26666 11.9426 5.05742 14.7333 8.5 14.7333Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M8.5 4.0611V12.9389"
      stroke="white"
      strokeWidth="1.15"
      strokeLinecap="round"
    />
    <path
      d="M10.4833 6.13891C10.0111 5.38335 9.30279 5.0528 8.50001 5.0528C7.4139 5.0528 6.51667 5.61946 6.51667 6.56391C6.51667 8.64168 10.4833 7.65002 10.4833 9.96391C10.4833 10.9556 9.58612 11.7111 8.50001 11.7111C7.60279 11.7111 6.84723 11.2861 6.46945 10.5306"
      stroke="white"
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

// Toothed gear — same glyph the startup app's Settings entry uses.
export const SettingsIcon = () => (
  <SidebarIcon viewBox="0 0 24 24">
    <path
      d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="3"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SidebarIcon>
);

export const ProfileIcon = () => (
  <SidebarIcon>
    <path
      d="M8.5 8.5C9.90474 8.5 11.0431 7.36163 11.0431 5.95689C11.0431 4.55215 9.90474 3.41378 8.5 3.41378C7.09526 3.41378 5.95689 4.55215 5.95689 5.95689C5.95689 7.36163 7.09526 8.5 8.5 8.5Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path
      d="M3.77777 14.1667V13.2222C3.77777 12.2211 4.17537 11.261 4.88301 10.5533C5.59065 9.84571 6.55081 9.44812 7.55193 9.44812H9.44804C10.4492 9.44812 11.4093 9.84571 12.117 10.5533C12.8246 11.261 13.2222 12.2211 13.2222 13.2222V14.1667"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </SidebarIcon>
);

export const BillingPlanIcon = () => (
  <SidebarIcon>
    <path
      d="M13.2222 4.25H3.77778C2.99538 4.25 2.36111 4.88426 2.36111 5.66667V11.3333C2.36111 12.1157 2.99538 12.75 3.77778 12.75H13.2222C14.0046 12.75 14.6389 12.1157 14.6389 11.3333V5.66667C14.6389 4.88426 14.0046 4.25 13.2222 4.25Z"
      stroke="white"
      strokeWidth="1.3"
    />
    <path d="M2.36111 7.08333H14.6389" stroke="white" strokeWidth="1.3" />
  </SidebarIcon>
);
